import { CoefficientSource, ICycleScoringConfiguration } from 'app/entities/cycle/cycle.reducer';
import { ClasseRow, CoefficientsState, MatiereRow, SousMatieresState, pairKey } from './pedagogie-wizard.types';

const isValid = (value: number | null | undefined): value is number => Number.isInteger(value) && value >= 1;

export const buildScoringConfiguration = (
  matieres: MatiereRow[],
  classes: ClasseRow[],
  sousMatieres: SousMatieresState,
  sources: Record<string, CoefficientSource>,
  coefficients: CoefficientsState,
  sousCoefficients: CoefficientsState
): ICycleScoringConfiguration => {
  const result: ICycleScoringConfiguration = { matieres: [], coefficients: [], sousMatiereCoefficients: [] };
  const missing: string[] = [];
  matieres.forEach(matiere => {
    const source = sources[matiere.cycleMatiereId] || 'MATIERE';
    const children = (sousMatieres[pairKey(matiere.cycleId, matiere.id)] || []).filter(row => !row.deleted && row.actif !== false);
    if (source === 'SOUS_MATIERES' && (!matiere.avecSousMatieres || children.length === 0)) {
      throw new Error(`${matiere.nom} : choisissez le coefficient général ou ajoutez des sous-matières actives.`);
    }
    result.matieres.push({ cycleMatiereId: matiere.cycleMatiereId, coefficientSource: source });
    classes.forEach(classe => {
      const value = coefficients[matiere.id]?.[classe.id];
      if (source === 'MATIERE') {
        if (!isValid(value)) missing.push(`${matiere.nom} / ${classe.nom}`);
        else result.coefficients.push({ matiereId: matiere.id, classeId: classe.id, coefficient: value });
      }
      if (source === 'SOUS_MATIERES') {
        children.forEach(child => {
          const detailedValue = sousCoefficients[child.id]?.[classe.id];
          if (!isValid(detailedValue)) missing.push(`${matiere.nom} — ${child.nom} / ${classe.nom}`);
          else result.sousMatiereCoefficients.push({ sousMatiereId: child.id, classeId: classe.id, coefficient: detailedValue });
        });
      }
    });
  });
  if (missing.length)
    throw new Error(`Coefficients manquants ou invalides : ${missing.join(', ')}. La stratégie enregistrée reste inchangée.`);
  return result;
};
